import { CartRewardData } from 'src/items-list/business-logic/service/interfaces/cart-response';
import { showRedeemRewardsLanding } from 'src/tendering/components/monetary-rewards/redeem-rewards-landing';
import { showRedeemRewardsAmount } from 'src/tendering/components/monetary-rewards/redeem-rewards-amount';
import { restorePage } from 'src/common/components/emerald-home-page/emerald-home-page';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { redeemStoredValueReward, RewardApprovalBody } from 'src/common/helpers/transaction-helper';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';
import { applyCartResponse } from './common/apply-cart-response';
import { popupAsyncMessage } from 'src/messages/business-logic/popup-message';
import { PromotionCanNotBeApplied } from 'src/common/helpers/error-code';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';

export const getMonetaryStoredValuePromotions = async (
  rewards: CartRewardData[],
): Promise<void> => {
  const reward = rewards.reduce((prev: CartRewardData, current: CartRewardData): CartRewardData => {
    const prevAmount = prev.redeemableLoyaltyProgram?.amount || 0;
    const currentAmount = current.redeemableLoyaltyProgram?.amount || 0;

    return prevAmount > currentAmount ? prev : current;
  }, rewards[0]);

  const rewardRequest: RewardApprovalBody = {
    approved: true,
    promotionId: reward.promotionId ?? '',
    programId: reward.redeemableLoyaltyProgram?.programId ?? '',
  };

  return new Promise<void>((resolve, reject) => {
    const notNowHandler = async (): Promise<void> => {
      const span = createSpan('Redeem Rewards No Button');
      rewardRequest.approved = false;
      await withSpinner(async () => {
        await redeemStoredValueReward(rewardRequest)
          .then(() => resolve())
          .catch(err => {
            reject(err);
          });
      });
      endSpan(span);
    };

    const partialHandler = (): void => {
      const span = createSpan('Redeem Rewards Partial Button');
      const inputCallback = rewardRequest =>
        redeemStoredValueReward(rewardRequest)
          .then(applyCartResponse)
          .then(() => resolve())
          .catch(err => {
            reject(err);
          });
      showRedeemRewardsAmount({ reward, notNowHandler, backHandler, inputCallback });
      endSpan(span);
    };

    const allHandler = async (): Promise<void> => {
      const span = createSpan('Redeem Rewards All Button');
      rewardRequest.amount = reward.redeemableLoyaltyProgram?.amount;
      await withSpinner(async () => {
        await redeemStoredValueReward(rewardRequest)
          .then(applyCartResponse)
          .then(() => resolve())
          .catch(err => {
            reject(err);
          });
      });
      endSpan(span);
    };

    const backHandler = async (): Promise<void> => {
      const span = createSpan('Back');
      restorePage();
      endSpan(span);
    };

    showRedeemRewardsLanding({
      reward,
      notNowHandler,
      partialHandler,
      allHandler,
    });
  });
};

export const handleRewardPostErrors = (err: any) => {
  if (!!err.code && err.code === PromotionCanNotBeApplied) {
    return popupAsyncMessage({
      message: 'PromotionCannotBeApplied',
      type: EmeraldDialogTypes.Error,
      subMessage: err.message,
    });
  } else {
    return popupAsyncMessage({
      message: 'CommunicationError',
      type: EmeraldDialogTypes.Error,
      subMessage: 'MSVPostApprovalFailed',
    });
  }
};
